export default __webpack_public_path__ + "static/media/insource-logo.bf7005a9.png";